














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class LinkedInIcon extends Vue {
  @Prop({ default: '25' }) readonly width?: string;
  @Prop({ default: '24' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
